import type { ComponentProps } from "react";
import { styled } from "@repo/styled-system/jsx";
import { type HeadingVariantProps, heading } from "@repo/styled-system/recipes";
import type { StyledComponent } from "@repo/styled-system/types";

type Props = HeadingVariantProps & { as?: React.ElementType };

export type HeadingProps = ComponentProps<typeof Heading>;
export const Heading = styled("h2", heading) as StyledComponent<"h2", Props>;
